import createClient from "openapi-fetch"
import type { paths } from "../openapi-schema"
import { env } from "./env"

export function getApiClient() {
  return createClient<paths>({
    baseUrl: env.BLUEPRINT_API_URL,
    headers: {
      "x-api-key": env.BLUEPRINT_API_KEY,
    },
  })
}
